(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var countSelectors = [
    '.sports-cart-count',
    '[data-solvex-mobile-cart-count]',
    '.cart-count-bubble > span[aria-hidden="true"]',
    '[data-cart-count]'
  ].join(',');

  function updateCartCounts(itemCount) {
    var count = Number(itemCount);
    if (!Number.isFinite(count)) return;

    document.querySelectorAll(countSelectors).forEach(function (badge) {
      badge.textContent = String(count);
      badge.toggleAttribute('hidden', count === 0 && badge.hasAttribute('data-hide-when-empty'));
    });

    document.querySelectorAll('#cart-icon-bubble, [data-solvex-mobile-cart]').forEach(function (cartLink) {
      var accessibleText = count === 1 ? 'Cart, 1 item' : 'Cart, ' + count + ' items';
      var hiddenText = cartLink.querySelector('.visually-hidden');
      if (hiddenText) hiddenText.textContent = accessibleText;
      else cartLink.setAttribute('aria-label', accessibleText);
    });

    document.dispatchEvent(new CustomEvent('solvex:cart-count-updated', { detail: { itemCount: count } }));
  }

  function getVisibleCartTarget() {
    return Array.from(document.querySelectorAll('#cart-icon-bubble, [data-solvex-mobile-cart]')).find(function (element) {
      var rect = element.getBoundingClientRect();
      var style = window.getComputedStyle(element);
      return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none';
    });
  }

  function getSourceImage(context) {
    var root = context instanceof Element ? context : document;
    var card = root.closest?.('[data-solvex-product-card], [data-solvex-carousel-card]');
    var section = root.closest?.('.product, product-info, .featured-product');
    return card?.querySelector('[data-solvex-product-image-link] img, .card__media img, [data-solvex-product-image]') ||
      section?.querySelector('.product__media img, .global-media-settings img');
  }

  function pulseCart(target) {
    if (!target || reducedMotion.matches) return;
    target.classList.remove('solvex-cart-pulse');
    target.getBoundingClientRect();
    target.classList.add('solvex-cart-pulse');
    window.setTimeout(function () { target.classList.remove('solvex-cart-pulse'); }, 420);
  }

  function flyToCart(sourceImage) {
    var target = getVisibleCartTarget();
    if (!target) return;
    if (!sourceImage || reducedMotion.matches) {
      pulseCart(target);
      return;
    }

    var start = sourceImage.getBoundingClientRect();
    var finish = target.getBoundingClientRect();
    if (!start.width || !start.height || !finish.width || !finish.height) {
      pulseCart(target);
      return;
    }

    var clone = sourceImage.cloneNode(true);
    var startSize = Math.min(112, Math.max(64, Math.min(start.width, start.height) * 0.34));
    var startX = start.left + (start.width - startSize) / 2;
    var startY = start.top + (start.height - startSize) / 2;
    var endX = finish.left + finish.width / 2 - startSize / 2;
    var endY = finish.top + finish.height / 2 - startSize / 2;

    clone.className = 'solvex-fly-image';
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('id');
    clone.style.width = startSize + 'px';
    clone.style.height = startSize + 'px';
    clone.style.left = startX + 'px';
    clone.style.top = startY + 'px';
    document.body.appendChild(clone);

    var animation = clone.animate([
      { transform: 'translate3d(0,0,0) scale(1)', opacity: 0.96, offset: 0 },
      { transform: 'translate3d(' + ((endX - startX) * 0.55) + 'px,' + ((endY - startY) * 0.38 - 34) + 'px,0) scale(.68)', opacity: 0.9, offset: 0.52 },
      { transform: 'translate3d(' + (endX - startX) + 'px,' + (endY - startY) + 'px,0) scale(.16)', opacity: 0.08, offset: 1 }
    ], { duration: 680, easing: 'cubic-bezier(.22,.72,.24,1)', fill: 'forwards' });

    animation.finished.catch(function () {}).finally(function () {
      clone.remove();
      pulseCart(target);
    });
  }

  function fetchCart() {
    return fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Unable to refresh the cart.');
      return response.json();
    });
  }

  function handleAddSuccess(options) {
    var sourceImage = getSourceImage(options?.button || options?.form || document.body);
    flyToCart(sourceImage);
    return fetchCart().then(function (cart) {
      updateCartCounts(cart.item_count);
      return cart;
    }).catch(function () {
      return null;
    });
  }

  function initVariantLinks(root) {
    (root || document).querySelectorAll('[data-solvex-variant-link]').forEach(function (button) {
      if (button.dataset.solvexVariantReady === 'true') return;
      button.dataset.solvexVariantReady = 'true';
      button.addEventListener('click', function () {
        var productUrl = button.dataset.solvexVariantLink;
        if (productUrl) window.location.assign(productUrl);
      });
    });
  }

  window.SolvexCommerce = {
    updateCartCounts: updateCartCounts,
    handleAddSuccess: handleAddSuccess,
    flyToCart: flyToCart,
    fetchCart: fetchCart
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event?.source === 'product-form') return;
      var itemCount = event?.cartData?.item_count;
      if (Number.isFinite(Number(itemCount))) updateCartCounts(itemCount);
      else fetchCart().then(function (cart) { updateCartCounts(cart.item_count); }).catch(function () {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initVariantLinks(document); }, { once: true });
  } else {
    initVariantLinks(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initVariantLinks(event.target); });
})();
